module.exports = __webpack_public_path__ + "b20c30ade92c494f65a63cff86ce33ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/N1533.jpg
// module id = 690
// module chunks = 0